<template>
	<div class="container page">
		<div class="section">
			<BaseOverlay v-bind:isLoading="isLoading" />
			<div v-if="errors.length > 0" class="content profile">
				<BaseErrors v-bind:errors="errors" />
			</div>		
			<div v-if="profile && errors.length === 0" class="content profile">
				<div class="field">
					<div class="label col">Логин</div>
					<div class="value col">{{profile.uid}}</div>
				</div>
				<div class="field">
					<div class="label col">Email</div>
					<div class="value col">{{profile.email}}</div>
				</div>
				<div class="field">
					<div class="label col">Полное имя</div>
					<div class="value col">{{profile.fullName}}</div>
				</div>
				<div class="field">
					<div class="label col">Имя</div>
					<div class="value col">{{profile.firstName}}</div>
				</div>
				<div class="field">
					<div class="label col">Фамилия</div>
					<div class="value col">{{profile.lastName}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { FETCH_PROFILE } from '@/store/actions.type'
import BaseOverlay from '@/components/views/Manager/Shared/BaseOverlay'
import BaseErrors from '@/components/views/Manager/Shared/BaseErrors'

export default {
	name: 'Profile',
	created () {
		this.$store.dispatch(FETCH_PROFILE)
	},
	components : {
		BaseErrors,
		BaseOverlay
	},
	computed: {
		...mapGetters({
			profile: 'profile',
			isLoading: 'profileIsLoading',
			errors: 'profileErrors',
		})
	}
}

</script>

<style scoped>
.profile {
	display: flex;
	flex-direction: column;
	border-radius: 2px;
	box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2);
	background-color: aliceblue;
}
.col {
	font-size: 1.25rem;
	line-height: 1.25;
}
.field {
	display: flex;
	flex-direction: row;
	padding: 24px;
	width: 100%;
	border-bottom: 1px solid darkgray;
}
@media only screen and (max-width: 450px) {
	.field {
		flex-direction: column;
	}
}
.label {
	padding-right: 10px;
	width: 224px;
	-webkit-flex-shrink: 0;
	flex-shrink: 0;
	color: #181818;
	font-size: 16px;
	font-weight: normal;
}
.value {
	-webkit-box-flex: 1;
	box-flex: 1;
	-webkit-flex-grow: 1;
	flex-grow: 1;
	-webkit-flex-shrink: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	word-wrap: normal;
	color: rgba(0,0,0,0.65);
	font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/views/Profile/Profile.vue